import { Map, fromJS } from 'immutable';
import { get, pick } from 'lodash';
import { ACTUALIZE_PACKAGE_SUCCESS } from '../constants/actualization';
import { PREBUILD_ORDER_SUCCESS } from '../constants/order';
import {
  UPDATE_PACKAGE_ID,
  SIMILAR_PACKAGES_GET_PACKAGE_PARAMS,
  CREATE_PACKAGE_SUCCESS,
} from '../constants/similar-packages';
import { changePackage } from '../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives/slice';

const initialState = Map();
const PACKAGE_FIELDS = [
  'availability',
  'extras',
  'price',
  'fuel_charge',
  'net_price',
  'transfer',
  'medical_insurance',
  'previous_price',
  'insurable',
  'misc_data',
  'instant_confirm',
  'labels',
  'cancellation_policy',
  'confirmability_index',
  'tour_id',
  ...SIMILAR_PACKAGES_GET_PACKAGE_PARAMS,
];

const getPackageData = ({ type, payload }) => {
  switch (type) {
    case ACTUALIZE_PACKAGE_SUCCESS:
      return get(payload, 'data.package');
    case PREBUILD_ORDER_SUCCESS:
      return get(payload, 'data.order.package');
    case CREATE_PACKAGE_SUCCESS:
    case changePackage.type:
      return payload;
    default:
      return null;
  }
};

export default function packageReducer(state = initialState, action) {
  switch (action.type) {
    case PREBUILD_ORDER_SUCCESS:
    case ACTUALIZE_PACKAGE_SUCCESS:
    case changePackage.type:
    case CREATE_PACKAGE_SUCCESS: {
      const packageData = getPackageData(action);
      const newState = fromJS({
        ...pick(packageData, PACKAGE_FIELDS),
        archived_at: undefined, // При замене архивного пакета другим, в сторе убираем поле archived_at
      });
      return state.merge(newState);
    }
    case UPDATE_PACKAGE_ID:
      return state.set('id', fromJS(action.payload));
    default:
      return state;
  }
}
